import { connect } from 'react-redux';

import { checkFeatureFlagHasToken } from 'app/selectors';

import { Carsale24Page } from './Carsale24Page';
import { ICarSale24PageProps } from './CarSale24Page.types';

type TStateProps = Pick<ICarSale24PageProps, 'isFlag244ShowCarsale24Form'>;

const mapStateToProps = (state: TRootState): TStateProps => ({
  isFlag244ShowCarsale24Form: checkFeatureFlagHasToken(
    state,
    244,
    'show_variant',
  ),
});

export const ConnectedCarsale24Page = connect<TStateProps>(mapStateToProps)(
  Carsale24Page,
);
